import { render, staticRenderFns } from "./userProfileDialog.vue?vue&type=template&id=eb30e584"
import script from "./userProfileDialog.vue?vue&type=script&lang=js"
export * from "./userProfileDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports